/**
 * @generated SignedSource<<763c3639a5af9715ba945c57f1d4b0e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UserTransactionState = "CANCELING" | "CANCELLED" | "PENDING" | "REJECTED" | "REQUESTED" | "SUCCESSFUL" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Transaction_userTransaction$data = {
  readonly createdDate: string;
  readonly nonce: number;
  readonly state: UserTransactionState | null | undefined;
  readonly transactionHash: string | null | undefined;
  readonly " $fragmentType": "Transaction_userTransaction";
};
export type Transaction_userTransaction$key = {
  readonly " $data"?: Transaction_userTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"Transaction_userTransaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Transaction_userTransaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nonce",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionHash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdDate",
      "storageKey": null
    }
  ],
  "type": "UserTransactionType",
  "abstractKey": null
};

(node as any).hash = "3823642b5f4353379b9eff1b72b8997d";

export default node;
